export default [
  'BOTCityDetails',
  'BOTServicesList'
]

/*
Appears on:
location/state/city,
*/
